import {SET_CONTENT_LOADING } from '../actions/actionTypes'

const initState = {
    loadingStatus : 0
}

const filetraceReducer = (state = initState, action) => {
    // , JSON.stringify(action)
    // console.log(action.info)
    switch(action.type){
        case SET_CONTENT_LOADING : return {
            ...state,
            loadingStatus : state.loadingStatus+1
        }
        default : return state
    }
};

export default filetraceReducer;